<div class="approval_card">
    <div class="approval_title">
        <h4>{{ 'SETTING_PAGE.IDMS_SETTINGS.NEW_REQUESTS' | transloco }}</h4>
    </div>

    <div class="approval_card_section">
        <div class="table_responsive" *ngIf="pendingApprovalList?.length > 0">
            <mat-paginator
                *ngIf="pendingApprovalList?.length > 10"
                [length]="pendingApprovalList?.length"
                [pageSize]="10"
                [pageSizeOptions]="[5, 10, 20]"
                showFirstLastButtons
            >
            </mat-paginator>
            <table mat-table [dataSource]="dataSource" class="mat-elevation-z8 mat-table-wrapper">
                <ng-container matColumnDef="initiator">
                    <th mat-header-cell *matHeaderCellDef>{{ 'SETTING_PAGE.IDMS_SETTINGS.INITIATOR' | transloco }}</th>
                    <td mat-cell *matCellDef="let element">{{ element.initiator }}</td>
                </ng-container>

                <ng-container matColumnDef="trigger">
                    <th mat-header-cell *matHeaderCellDef>{{ 'SETTING_PAGE.IDMS_SETTINGS.TRIGGER' | transloco }}</th>
                    <td mat-cell *matCellDef="let element">{{ element.trigger?.value }}</td>
                </ng-container>
                <ng-container matColumnDef="startDate">
                    <th mat-header-cell *matHeaderCellDef>{{ 'SETTING_PAGE.IDMS_SETTINGS.START_DATE' | transloco }}</th>
                    <td mat-cell *matCellDef="let element">{{ element.startDate | customDateTimeFormat }}</td>
                </ng-container>
                <ng-container matColumnDef="name">
                    <th mat-header-cell *matHeaderCellDef>{{ 'SETTING_PAGE.IDMS_SETTINGS.ITEM' | transloco }}</th>
                    <td mat-cell *matCellDef="let element">{{ element.name }}</td>
                </ng-container>
                <ng-container matColumnDef="item">
                    <th mat-header-cell *matHeaderCellDef>{{ 'SETTING_PAGE.IDMS_SETTINGS.ITEM_TYPE' | transloco }}</th>
                    <td mat-cell *matCellDef="let element">{{ element.item?.value }}{{ element?.type ? '(' + element?.type + ')' : '' }}</td>
                </ng-container>
                <!-- <ng-container matColumnDef="state">
                    <th mat-header-cell *matHeaderCellDef>State</th>
                    <td mat-cell *matCellDef="let element">{{ stateMap[element.state] }}</td>
                </ng-container> -->
                <ng-container matColumnDef="action">
                    <th mat-header-cell *matHeaderCellDef>{{ 'SETTING_PAGE.IDMS_SETTINGS.ACTION' | transloco }}</th>
                    <td mat-cell *matCellDef="let element">{{ element.action.value }}</td>
                </ng-container>
                <ng-container matColumnDef="actions">
                    <th mat-header-cell *matHeaderCellDef>{{ 'SETTING_PAGE.IDMS_SETTINGS.ACTIONS' | transloco }}</th>
                    <td mat-cell *matCellDef="let element">
                        <div class="displayFlex">
                            <i
                                class="mdi mdi-eye"
                                style="position: relative; cursor: pointer; align-items: center; vertical-align: middle"
                                #tooltip="matTooltip"
                                matTooltip="{{ 'SETTING_PAGE.IDMS_SETTINGS.VIEW' | transloco }}"
                                [matTooltipPosition]="tooltip_position"
                            ></i>

                            <i
                                class="mdi mdi-check-circle"
                                *ngIf="element.action.key != 1 && iseditApprovals"
                                style="position: relative; cursor: pointer; align-items: center; vertical-align: middle"
                                #tooltip="matTooltip"
                                matTooltip="{{ 'SETTING_PAGE.IDMS_SETTINGS.APPROVE' | transloco }}"
                                [matTooltipPosition]="tooltip_position"
                                (click)="approveAction(element, 1)"
                            ></i>

                            <i
                                class="mdi mdi-close-circle"
                                *ngIf="element.action.key != 1 && iseditApprovals"
                                style="position: relative; cursor: pointer; align-items: center; vertical-align: middle"
                                #tooltip="matTooltip"
                                matTooltip="{{ 'SETTING_PAGE.IDMS_SETTINGS.REJECT' | transloco }}"
                                [matTooltipPosition]="tooltip_position"
                                (click)="approveAction(element, 2)"
                            ></i>
                            <i
                                class="mdi mdi-handshake"
                                *ngIf="element.action.key == 1 && iseditApprovals"
                                style="position: relative; cursor: pointer; align-items: center; vertical-align: middle"
                                #tooltip="matTooltip"
                                matTooltip="{{ 'SETTING_PAGE.IDMS_SETTINGS.ACKNOWLEDGE' | transloco }}"
                                [matTooltipPosition]="tooltip_position"
                                (click)="approveAction(element, 3)"
                            ></i>
                        </div>
                    </td>
                </ng-container>
                <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
            </table>
        </div>
        <div class="col-md-12 no-type d-flex align-items-center justify-content-center w-100 nodata" *ngIf="pendingApprovalList?.length == 0">
            <h3>{{ 'SETTING_PAGE.IDMS_SETTINGS.NO_DATA_AVAILABLE_TO_DISPLAY_HERE_PLEASE_COME_BACK_LATER' | transloco }}</h3>
        </div>
    </div>
</div>
